var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    class: ['activity-btn-intro-loader', {
      active: !_vm.isLoading
    }],
    attrs: {
      "aria-label": "Continue",
      "tabindex": "1"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('svg', {
    attrs: {
      "id": "activityIntroBtn",
      "x": "0px",
      "y": "0px",
      "width": "69px",
      "height": "136px",
      "viewBox": "0 0 69 136"
    }
  }, [_c('g', {
    attrs: {
      "id": "btnSemiCircle"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#F9E945",
      "d": "M8.4,42.4C4.9,50.5,3.2,59,3.2,67.9s1.7,17.3,5.2,25.4c3.3,7.8,8,14.7,14.1,20.8c6.1,6,13,10.7,20.9,14\n        c8.1,3.4,16.7,5.1,25.6,5.1V2.5c-8.9,0-17.5,1.7-25.6,5.1c-7.9,3.3-14.8,8-20.9,14S11.7,34.6,8.4,42.4z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#010101",
      "d": "M58.8,5.1c1-0.1,2.4-0.3,4.3-0.4l0.8-0.1c0.6,0,1.4-0.2,2.4-0.4C67.5,4.1,68.4,4,69,4V0.4\n        c-0.9,0-2,0.1-3.3,0.4c-0.8,0.2-1.5,0.3-2.1,0.3l-0.8,0.1c-1.8,0.1-3.3,0.3-4.6,0.5c0,0-0.7,0.1-2,0.2c-1.3,0.1-2.5,0.3-3.4,0.5\n        c-0.8,0.2-1.8,0.6-3.1,1.2c-0.9,0.4-1.6,0.7-1.9,0.8l-1.1,0.4c-1.5,0.5-2.9,1-4,1.4l-2,0.8c-1.9,0.7-3.2,1.3-4,1.7\n        c-1.2,0.6-2.8,1.6-4.7,3l-1.3,0.8c-2.3,1.5-3.9,2.7-4.8,3.4c-0.7,0.6-1.7,1.6-3,3l-1.6,1.7c-1.4,1.4-2.9,3-4.4,4.7\n        c-0.9,1.2-2.1,2.7-3.4,4.7l-0.4,0.6c-1.4,2.1-2.6,3.9-3.4,5.5c-1,1.8-2,3.8-2.8,5.8c-0.9,2.1-1.5,3.7-1.9,5\n        c-0.2,0.5-0.5,1.1-0.8,1.9c-0.6,1.4-1,2.5-1.2,3.1c-0.2,0.7-0.3,1.8-0.4,3.3c0,0.9-0.1,1.6-0.2,2.1l-0.4,2\n        c-0.3,1.4-0.5,2.5-0.6,3.3c-0.1,1-0.1,2.4-0.1,4.4l0,1c0,0.8,0.1,2,0.3,3.4l0.2,1.9c0,0.7,0,1.3,0,2.1c0,1.3,0,2.4,0.1,3.3\n        c0.1,0.7,0.4,1.8,0.9,3.3l0.5,1.9c0.2,0.8,0.6,1.9,1.1,3.4l1.1,3.2c0.6,1.9,1.1,3.1,1.2,3.5l0.6,1.4c0.9,2.1,1.6,3.7,2.1,4.6\n        c0.5,0.9,1.3,2.1,2.4,3.4l2.6,3.8c1,1.6,1.8,2.8,2.3,3.4c0.9,1,1.9,2.2,3.3,3.4l1.2,1.2c0.2,0.2,0.8,0.8,1.6,1.8\n        c1.2,1.4,2.1,2.3,2.9,3c1.1,0.9,2.8,2.1,5.3,3.8c2.4,1.6,4.2,2.7,5.6,3.4c0.8,0.4,2.1,1,4,1.7l2.1,0.8c1.8,0.8,3.4,1.4,5,1.9\n        c0.8,0.3,2,0.6,3.6,0.9l1.7,0.4c1.3,0.3,3.1,0.6,5.3,1c1.9,0.3,3.6,0.5,5.3,0.6c2.5,0.2,4.3,0.2,5.4,0.2v-3.5\n        c-1.7,0-3.4-0.1-5.1-0.2c-1.9-0.2-3.6-0.4-5.1-0.6c-1.7-0.3-3.4-0.6-5-0.9l-1.8-0.4c-1.6-0.4-2.6-0.6-3.2-0.8\n        c-1-0.3-2.6-0.9-4.7-1.8l-2.2-0.9c-1.6-0.6-2.8-1.1-3.5-1.5c-1.2-0.6-2.9-1.7-5.3-3.3c-2.1-1.4-3.7-2.6-5-3.6\n        c-0.4-0.3-1.2-1.2-2.4-2.5c-0.6-0.8-1.2-1.4-1.8-2l-1.3-1.3c-1.4-1.4-2.4-2.4-3-3.1c-0.6-0.8-1.3-1.8-2-3.1\n        c-0.9-1.4-1.3-2.1-1.3-2.1c-0.3-0.4-0.8-1.1-1.5-2c-1-1.3-1.7-2.3-2.1-3c-0.4-0.8-1.1-2.2-1.9-4.3l-0.6-1.3C9.9,92,9.5,90.9,9,89.4\n        l-1.2-3.4c-0.5-1.2-0.8-2.2-1-3l-0.6-2c-0.4-1.2-0.6-2.2-0.7-2.9c-0.1-0.4-0.1-1.3-0.1-2.6c0-0.9,0-1.7,0-2.5\n        c0-0.5-0.1-1.2-0.2-2.1c-0.2-1.2-0.2-2.2-0.2-2.9l0-1.1c0-1.8,0-3.2,0.1-4c0-0.7,0.2-1.6,0.5-2.8l0.5-2.2c0.1-0.6,0.2-1.4,0.2-2.4\n        c0.1-1.4,0.2-2.3,0.3-2.7c0.2-0.6,0.5-1.4,1-2.5c0.4-0.8,0.7-1.6,1-2.3c0.5-1.4,1.1-3,1.8-4.7c0.8-1.8,1.7-3.6,2.7-5.5\n        c0.8-1.5,1.9-3.2,3.2-5.2l0.4-0.6c1.4-2,2.4-3.4,3.2-4.4c1.3-1.6,2.7-3.1,4.2-4.5l1.7-1.8c1.2-1.3,2.1-2.2,2.6-2.6\n        c1-0.8,2.5-1.9,4.5-3.2l1.3-0.8c2.3-1.5,3.8-2.4,4.5-2.8c0.7-0.4,1.9-0.9,3.6-1.5l2.1-0.8c0.9-0.4,2.1-0.8,3.7-1.3L49,7.7\n        c0.7-0.2,1.4-0.5,2.3-0.9c1.3-0.5,2.1-0.9,2.5-0.9c0.5-0.1,1.5-0.3,2.9-0.4C57.6,5.3,58.3,5.2,58.8,5.1z"
    }
  })]), _c('g', {
    attrs: {
      "id": "arrowGroup"
    }
  }, [_c('path', {
    attrs: {
      "id": "arrowCircleBg",
      "fill": "#F9E945",
      "fill-opacity": "0",
      "d": "M59.7,45.6c-6.2-6.2-13.7-9.2-22.4-9.2c-8.8,0-16.2,3.1-22.4,9.2\n        c-6.2,6.1-9.3,13.5-9.3,22.2c0,8.7,3.1,16.1,9.3,22.2c6.2,6.2,13.6,9.2,22.4,9.2c8.7,0,16.2-3.1,22.4-9.2\n        c6.2-6.2,9.3-13.6,9.3-22.2C69,59.1,65.9,51.7,59.7,45.6z"
    }
  }), _c('g', {
    attrs: {
      "id": "arrow"
    }
  }, [_c('path', {
    attrs: {
      "d": "M48.9,48.4L35.3,37.1l-0.3,5c-5.5,0.5-10.3,2.5-14.5,6c-4.2,3.5-7,7.9-8.4,13.3l-0.3,0.9l8.5,2.2l0.3-1\n          c0.8-3.2,2.4-5.9,4.9-8.1c2.4-2.3,5.2-3.7,8.4-4.3l-0.8,4.1L48.9,48.4z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M34.5,53.5L47,48.2l-10.8-9L36,43.1c-5.4,0.3-10.2,2.1-14.5,5.5c-4.3,3.4-7,7.8-8.4,13.1l6.5,1.6\n          c0.9-3.6,2.8-6.7,5.7-9.1c2.8-2.4,6.1-3.9,9.8-4.3L34.5,53.5z"
    }
  })]), _c('g', {
    attrs: {
      "id": "arrow_1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.6,67.5l-3,17.4l4.5-2.3c3.1,4.5,7.3,7.7,12.4,9.6c5.2,1.9,10.4,2.1,15.7,0.6l0.9-0.3l-2.4-8.5l-1,0.3\n          c-3.1,0.9-6.3,0.8-9.5-0.2c-3.2-1-5.8-2.7-8-5.1l4-1.4L14.6,67.5z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M26.3,77.4l-10.9-8.1L13,83.1l3.5-1.8c2.9,4.6,7,7.8,12,9.8c5.1,2,10.3,2.2,15.5,0.7l-1.8-6.5\n          c-3.6,1-7.2,0.9-10.8-0.4c-3.5-1.2-6.4-3.3-8.6-6.3L26.3,77.4z"
    }
  })]), _c('g', {
    attrs: {
      "id": "arrow_2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M48.3,87.6l16.5-6.1l-4.2-2.8c2.3-5,3-10.2,2.1-15.6c-0.9-5.4-3.4-10-7.3-13.9l-0.7-0.7l-6.2,6.3l0.7,0.7\n          c2.3,2.3,3.9,5,4.6,8.3c0.8,3.2,0.6,6.4-0.5,9.5l-3.2-2.7L48.3,87.6z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M51.1,72.6l-1.6,13.5l13.2-4.9l-3.3-2.1c2.5-4.8,3.3-9.9,2.4-15.3c-0.8-5.4-3.2-10-7.1-13.8L50,54.9\n          c2.7,2.6,4.4,5.8,5,9.5c0.7,3.6,0.3,7.2-1.2,10.6L51.1,72.6z"
    }
  })])]), _c('g', {
    attrs: {
      "id": "arrowGo"
    }
  }, [_c('path', {
    attrs: {
      "id": "arrowFill",
      "fill": "#FFFFFF",
      "d": "M40.5,84.1l19-19L41.1,47.2v7.7l-25.4,0.4v20.1h25.4L40.5,84.1z",
      "stroke": "black",
      "stroke-width": "2"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }